import "pixi";
import "phaser";
import * as i18n from "../i18n";
import * as logging from "../logging";
import BackButton from "../ui/back";

import { BlurX, BlurY } from "../effects/blur";

export default class CreditsState extends Phaser.State {
    bg: Phaser.Sprite;
    title: i18n.Text;
    privacy: i18n.Text;
    credits: i18n.Text;
    back: BackButton;

    create() {
        logging.startLevel(logging.LEVEL_CREDITS, null);
        this.bg = this.game.add.sprite(0, 0, "background2");
        this.bg.width = this.game.width;
        this.bg.height = this.game.height;

        this.back = new BackButton(this.game, () => {
            logging.finishLevel();
            this.state.start("title", true, false, true);
        });
        this.back.enable();

        this.title = i18n.label(this.game, this.game.width / 2, 48, i18n._("CREDITS & PRIVACY"), "font-large", 32);
        this.title.anchor.set(0.5, 0.5);

        this.privacy = i18n.label(this.game, 20, 96, i18n._("privacy-policy"), "font-credits", 24);
        i18n.wrapLabel(this.privacy, this.game.width - 40);

        this.credits = i18n.label(
            this.game, 20, 96 + 24 + i18n.labelHeight(this.privacy),
                i18n._("credits-opensource"),
            "font-credits", 24);
        i18n.wrapLabel(this.credits, this.game.width - 40);
    }
}



// WEBPACK FOOTER //
// ./src/states/credits.ts